<div>

  <div class="modalHeaderBlack height35" style="margin-bottom: 10px;">
    <h6 class="modal-title" style="font-size: 12px; font-weight: 500">Warning Appoinment Scheduled Overlapping</h6>
  </div>

  <h3 class="details-title">{{"EncounterPage.appointmentDetails" | translate}} :</h3>

  <div class="scroll-container" *ngIf="data?.appointments?.length">

    <div class="details-box" *ngFor="let apt of data.appointments">
      <p><b>{{"AppointmentPage.mrn" | translate}} :</b> {{ apt.hn }}</p>
      <p><b>{{"EncounterPage.name" | translate}} :</b> {{ apt.patientName }}</p>
      <p><b>{{"AppointmentListPage.appoinemtDateTime" | translate}} :</b> {{ apt.appointmentDateTime }}</p>
      <p><b>{{"AppointmentListPage.department" | translate}} :</b> {{ apt.department }}</p>
      <p><b>{{"RegistrationPage.doctor" | translate}} :</b> {{ apt.doctor }}</p>
      <p><b>{{"RegistrationPage.status" | translate}} :</b> {{ apt.status }}</p>
    </div>

  </div>

  <div class="message">
    <p>{{ data?.message }}</p>
  </div>

  <div class="actions">
    <button mat-raised-button class="btnCyan" (click)="onContinue()">
      Continue
    </button>

    <button mat-raised-button class="btnRed" (click)="onCancel()">
      Cancel
    </button>
  </div>

</div>